module.exports = __webpack_public_path__ + "static/media/chorthippus_apricarius_003_APA.9bffaeab.mp3";